import { Executor } from "../services";
import { getRoleDisplayName } from "../assets/languages/langs";

const haystackCache = new WeakMap<object, string>();

const namePart = (value: unknown): string => {
	if (typeof value === "string") return value;
	if (!value || typeof value !== "object") return "";
	return Object.values(value as Record<string, unknown>)
		.filter((item): item is string => typeof item === "string")
		.join(" ");
};

/**
 * Строка для поиска по водителю: позывной + ФИО (на всех языках). Считается
 * один раз на объект модели (подписка отдаёт стабильные объекты), поэтому
 * фильтрация большого списка на каждый символ — это один проход `includes`.
 */
function haystackOf(item: Executor.Model): string {
	const cached = haystackCache.get(item);
	if (cached !== undefined) return cached;

	const person: any = item.person ?? {};
	const value = [
		item.alias,
		namePart(person.lastName),
		namePart(person.firstName),
		namePart(person.fatherName),
		getRoleDisplayName(person.lastName),
		getRoleDisplayName(person.firstName),
	]
		.filter(Boolean)
		.join(" ")
		.toLowerCase();

	haystackCache.set(item, value);
	return value;
}

/**
 * Поиск по позывному и по ФИО: каждое слово запроса должно встретиться
 * (регистр не важен, порядок слов не важен).
 */
export function filterExecutorsBySearch(
	items: Executor.Model[],
	search: string | undefined | null,
): Executor.Model[] {
	const tokens = String(search ?? "")
		.trim()
		.toLowerCase()
		.split(/\s+/)
		.filter(Boolean);
	if (!tokens.length) return items;

	return items.filter((item) => {
		const haystack = haystackOf(item);
		return tokens.every((token) => haystack.includes(token));
	});
}

export default filterExecutorsBySearch;
